<template>
	<Route
		:routes="routes"
		:breadcrumbs="breadcrumbs"
	>
		<template slot="title">
			Settings
		</template>
		<v-container
			grid-list-xl
		>
			<transition
				:name="transition"
				mode="out-in"
			>
				<keep-alive>
					<router-view />
				</keep-alive>
			</transition>
		</v-container>
	</Route>
</template>

<script>
import StoreMethods from '@/mixins/StoreMethods';
import Route from '@/views/layouts/Route';
import axios from '@/util/axios';

export default {
	components: {
		Route,
	},
	mixins: [StoreMethods],
	data() {
		return {
			transition: '',
		};
	},
	computed: {
		breadcrumbs() {
			return [
				{ text: 'Dashboard', to: '/' },
				{ text: 'Settings', disabled: true },
			];
		},
		routes() {
			return [
				{ name: 'Features', to: { name: 'SettingsFeatures' } },
				{ name: 'Styles', to: { name: 'SettingsStyle' } },
				{ name: 'Projects', to: { name: 'SettingsProjects' } },
				{ name: 'Users', to: { name: 'SettingsUsers' } },
				// { name: 'Plan', to: { name: 'SettingsPlan' } },
				// { name: 'Security', to: { name: 'SettingsSecurity' } },
			];
		},
	},
	/** @todo Duplicated in few places, find a way to DRY it out */
	beforeRouteUpdate(to, from, next) {
		const fromIndex = this.routes.findIndex(r => r.to.name === from.name);
		const toIndex = this.routes.findIndex(r => r.to.name === to.name);

		if (fromIndex === toIndex) {
			this.transition = '';
		}
		else if (fromIndex < toIndex) {
			this.transition = 'slide-left';
		}
		else {
			this.transition = 'slide-right';
		}

		next();
	},
};
</script>
